import { EditorState } from 'draft-js'

/** Is DraftJS editor state have selected text. */
export default function editorStateHaveSelection(editorState: EditorState): boolean {
	return !editorState.getSelection().isCollapsed()
}
